import { Button } from '@material-ui/core';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import addDefaultAvatar from '../../actions/admin/addDefaultAvatar';
import useStore from '../../store/store';
import Dialog from '../Dialog';

interface AddDefaultAvatarDialogProps {
    open: boolean;
    onClose: () => void;
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const AddDefaultAvatarDialog = ({
    open,
    onClose,
}: AddDefaultAvatarDialogProps) => {
    const [avatars, setAvatars] = React.useState<File[]>([]);
    const isLoading = useStore((state) => state.isLoading);

    const handleAvatarFileChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const uploadedFiles = event.target.files;
        if (uploadedFiles) {
            setAvatars(Array.from(uploadedFiles));
        }
    };

    const handleClose = () => {
        if (isLoading) {
            return;
        }
        setAvatars([]);
        onClose();
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        await Promise.all(
            avatars.map((avatar) =>
                addDefaultAvatar({
                    avatar,
                })
            )
        );

        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            title={'Upload Default Avatars'}
            onSubmit={handleSubmit}
            submitDisabled={avatars.length === 0 || isLoading}
        >
            <Button
                color="primary"
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                style={{
                    marginTop: '1rem',
                    marginBottom: '1rem',
                    borderRadius: '25px',
                    boxShadow: 'none',
                    textTransform: 'none',
                    fontSize: '16px',
                }}
            >
                Upload Avatars
                <VisuallyHiddenInput
                    type="file"
                    onChange={handleAvatarFileChange}
                    accept="image/*"
                    multiple
                />
            </Button>
            {avatars.map((avatar) => (
                <p key={avatar.name}>{avatar.name}</p>
            ))}
        </Dialog>
    );
};

export default AddDefaultAvatarDialog;
